var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tableData)?_c('b-card',{staticClass:"card-company-table",attrs:{"no-body":""}},[_c('b-table',{staticClass:"mb-0",attrs:{"items":_vm.tableData,"responsive":"","fields":_vm.fields}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }